module.exports = __webpack_public_path__ + "img/customerio.28794fa1.png";